const MENU_CURATION_TASK_SCRAPING_REVIEW_ACTION_TYPE = {
  ACCEPT: 'ACCEPT',
  REJECT: 'REJECT',
  REQUEST_CLARIFICATION: 'REQUEST_CLARIFICATION',
}

export default MENU_CURATION_TASK_SCRAPING_REVIEW_ACTION_TYPE
